export default __webpack_public_path__ + "static/media/icon_dollar_active.3a2a7bba.svg";